<audio #audioRef [muted]="isMuted$ | async"></audio>
